import React from 'react';
import { useEffect, useState } from 'react';
import Address from "./addresscheck";
import Plans from "./plans";
import Modem from "./modem";
import Cart from "./cart";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import { getNBNApiHeader } from 'utlis/commonfunctions';

// import Services from "./services";
// import Banner from "./banner";
// import Queries from "./queries";
// import Faq from "./faq";
// import HeaderBanner from './headerbanner';


// function Home() {
const Home =({propdata}) =>{

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_TOKEN;
const headers = getNBNApiHeader();
const [vispID, setvispID] = useState(null);
const [defaultPlan, setDefaultPlan] = useState([]);
const [defaultModem, setDefaultModem] = useState([]);
const [checkVispValid, setCheckVispValid] = useState(false);
const [shippingCharge, setshippingCharge] = useState("0");
const [gstshippingCharge, setGstShippingCharge] = useState("0");
const [addressVerify, setAddressVerify] = useState(false);
const [nbnSessionId, setnbnSessionId] = useState(false);
const [AvailablePlan, setAvailablePlan] = useState([]);
const [apiToken, setApiToken] = useState(null);
const [addressError, setAddressError] = useState(false);






const userToken = sessionStorage.getItem('access_token')
useEffect(() => {
    //Loading address api on page loading time

    const fetchApiToken = async () => {
      try {
        const response = await fetch(apiUrl + 'nbn/get-auto-complete-address-token', {
            method: 'POST',
            headers:headers,
          });
        const data = await response.json();
        const tokenValue = data.data.token;
        setApiToken(tokenValue);
      } catch (error) {
        console.error('Error fetching API token:', error);
      }
    };

     fetchApiToken();
    }, []);
 
    
const getVispHandler = (input, e) => {

    // remove props change variable from address verification
    var vispqual_id = input;
    if(input !==null){ var vispqual_id =  input.split('nbn')[0]; }
    setvispID(vispqual_id);
   
};


const getAvailablePlan = (input, e) => {
    setAvailablePlan(input);
   
};

const getDefaultPlan = (input, e) => {
    setDefaultPlan(input);
   
};


const getDefaultModem = (input, e) => {
    setDefaultModem(input);
};



const getCheckValidVisp = (input, e) => {
    setCheckVispValid(input);
};

const getShippingCharge = (input, e) => {
  setshippingCharge(input);
};

const getGstShippingCharge = (input, e) => {
  setGstShippingCharge(input);
};



const addressVerified = (input, e) => {
    setAddressVerify(input);
    
};


const passNbnSessionId = (input, e) => {
    setnbnSessionId(input);
};
const AddressError =(input,e)=>{
  setAddressError(input)
}




  return (
        <>
        {/* <Banner title="HOME" description="Get High-Speed Internet At Your Fingertips."/> */}
        <DashboardLayout>
        <DashboardNavbar />
          <Address getVispHandler={getVispHandler} addressVerified = {addressVerified} passNbnSessionId={passNbnSessionId} getAvailablePlan={getAvailablePlan} tokenValue={apiToken}  userToken={userToken} addressError={addressError} AddressError={AddressError} />
          <Plans vispID = {vispID} getDefaultPlan = {getDefaultPlan} getCheckValidVisp = {getCheckValidVisp} addressVerify = {addressVerify} nbnSessionId={nbnSessionId} AvailablePlan={AvailablePlan} userToken={userToken}/>
          <Modem getDefaultModem = {getDefaultModem} getShippingCharge={getShippingCharge}   getGstShippingCharge={getGstShippingCharge}  userToken={userToken}/>
          <Cart defaultPlan = {defaultPlan} defaultModem = {defaultModem} checkVispValid = {checkVispValid}  addressVerify = {addressVerify} vispID = {vispID} nbnSessionId = {nbnSessionId} shippingCharge={shippingCharge}  gstshippingCharge={gstshippingCharge}  userToken={userToken}/>
          <Footer/>
          </DashboardLayout>
         
        </>    
  );
}

export default Home;
